import baseTheme from '../baseTheme'
const preDefined = {
  primary: '#0075C9',
  secondary: '#020F3D',
}
const cytolabTheme = {
  ...baseTheme,
  font: 'Dasa Sans',
  box: {
    background: baseTheme.baseColors.white,
    button: preDefined.secondary,
    border: preDefined.primary,
    text: baseTheme.baseColors.darkGray,
    textButton: baseTheme.colors.white,
  },
  header: {
    background: "#F58820",
    text: baseTheme.baseColors.lightBlack,
  },
}

export default cytolabTheme
